import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";


const PreviewItem = ({
    label,
    value,
}) => {

    return (
        <div className="border border-gray-200 rounded-md p-4">

            <p className="text-sm text-gray-500 mb-1">
                {label}
            </p>

            <p className="text-lg font-semibold text-gray-800 break-words">
                {value || "N/A"}
            </p>

        </div>
    );
};

const OnlineRegistration = () => {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        studentName: "",
        gender: "",
        fatherName: "",
        motherName: "",
        dob: "",
        mobile: "",
        admissionClass: "",
        stream: "",
        lastSchool: "",
        boardType: "",
        lastClass: "",
        overallPercentage: "",
        mathsPercentage: "",
        sciencePercentage: "",
        query: "",
        photo: null,
    });

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        setFormData({
            ...formData,
            [name]: files ? files[0] : value,
        });
    };
    const [loading, setLoading] =
        useState(false);

    const [message, setMessage] =
        useState("");

    const [error, setError] =
        useState("");

    const [showPreview, setShowPreview] =
        useState(false);

    const printRef = useRef();


    // SUBMIT
    const handleSubmit = async (
        e
    ) => {

        e.preventDefault();

        setLoading(true);
        setMessage("");
        setError("");

        try {

            const data =
                new FormData();

            Object.keys(formData).forEach(
                (key) => {

                    data.append(
                        key,
                        formData[key]
                    );

                }
            );

            const response =
                await fetch(
                    "https://stjosephweb.ilakshyaerp.in/api/online-registration/add",
                    {
                        method: "POST",
                        body: data,
                    }
                );

            const result =
                await response.json();

            if (!response.ok) {

                setError(
                    result.message ||
                    "Something went wrong ❌"
                );

                setLoading(false);
                return;
            }

            // SUCCESS
            setMessage(
                "Registration submitted successfully ✅"
            );

            setFormData({
                studentName: "",
                gender: "",
                fatherName: "",
                motherName: "",
                dob: "",
                mobile: "",
                admissionClass: "",
                stream: "",
                lastSchool: "",
                boardType: "",
                lastClass: "",
                overallPercentage: "",
                mathsPercentage: "",
                sciencePercentage: "",
                query: "",
                photo: null,
            });

        } catch (err) {

            setError(
                "Server error. Please try again later ❌"
            );

        } finally {

            setLoading(false);

        }
    };

    const handleDownload = () => {

        const photoURL =
            formData.photo
                ? URL.createObjectURL(formData.photo)
                : "";

        const printWindow =
            window.open("", "_blank");

        printWindow.document.write(`

    <html>

        <head>

            <title>
                Registration Form
            </title>

            <style>

                *{
                    margin:0;
                    padding:0;
                    box-sizing:border-box;
                    font-family: Arial, sans-serif;

                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                }

                body{
                    background:#f8fafc;
                    padding:18px;
                    color:#1e293b;
                    font-size:12px;
                }

                .container{
                    max-width:900px;
                    margin:auto;
                    background:white;
                    border-radius:10px;
                    overflow:hidden;
                    border:1px solid #dbe2ea;
                }

                /* HEADER */
                .header{
                    background:linear-gradient(to right,#072F5F,#0B5DB7);
                    padding:18px 24px;
                    color:white;
                }

                .header h1{
                    font-size:24px;
                    font-weight:700;
                    letter-spacing:0.5px;
                }

                .header p{
                    margin-top:4px;
                    font-size:12px;
                    opacity:0.9;
                }

                .content{
                    padding:24px;
                }

                .top{
                    display:flex;
                    justify-content:space-between;
                    align-items:flex-start;
                    gap:25px;
                    border-bottom:1px solid #dbe2ea;
                    padding-bottom:18px;
                    margin-bottom:22px;
                }

                .school-title{
                    flex:1;
                }

                .school-title h2{
                    font-size:18px;
                    color:#072F5F;
                    margin-bottom:6px;
                    font-weight:700;
                }

                .school-title p{
                    color:#64748b;
                    font-size:12px;
                    margin-bottom:12px;
                }

                .badge{
                    display:inline-block;
                    padding:5px 12px;
                    border-radius:20px;
                    font-size:10px;
                    font-weight:700;
                    margin-right:8px;
                }

                .blue{
                    background:#dbeafe;
                    color:#072F5F;
                }

                .green{
                    background:#dcfce7;
                    color:#166534;
                }

                .photo-box{
                    width:100px;
                    height:120px;
                    border-radius:8px;
                    overflow:hidden;
                    border:2px solid #dbe2ea;
                    flex-shrink:0;
                    background:#f1f5f9;
                }

                .photo-box img{
                    width:100%;
                    height:100%;
                    object-fit:cover;
                }

                /* SECTION TITLE */
                .section-title{
                    font-size:18px;
                    color:#072F5F;
                    margin-bottom:16px;
                    border-left:4px solid #0B5DB7;
                    padding-left:10px;
                    font-weight:700;
                }

                /* GRID */
                .grid{
                    display:grid;
                    grid-template-columns:1fr 1fr;
                    gap:12px;
                }

                .card{
                    background:#ffffff;
                    border:1px solid #dbe2ea;
                    border-radius:8px;
                    padding:12px;
                }

                .label{
                    font-size:10px;
                    color:#64748b;
                    text-transform:uppercase;
                    margin-bottom:6px;
                    font-weight:700;
                    letter-spacing:0.5px;
                }

                .value{
                    font-size:14px;
                    font-weight:600;
                    color:#0f172a;
                    word-break:break-word;
                }

                /* QUERY */
                .query-section{
                    margin-top:22px;
                }

                .query-box{
                    background:#ffffff;
                    border:1px solid #dbe2ea;
                    border-radius:8px;
                    padding:14px;
                    min-height:70px;
                    line-height:1.5;
                    color:#334155;
                    font-size:12px;
                }

                /* SIGNATURE */
                .signature{
                    display:flex;
                    justify-content:space-between;
                    margin-top:45px;
                    gap:30px;
                }

                .sign-box{
                    flex:1;
                    text-align:center;
                    border-top:1px solid #94a3b8;
                    padding-top:6px;
                    color:#475569;
                    font-size:11px;
                    font-weight:600;
                }

                @media print{

                    body{
                        padding:0;
                        background:white;
                    }

                    .container{
                        border:none;
                    }

                }

            </style>

        </head>

        <body>

            <div class="container">

                <div class="content">

                    <!-- TOP -->
                    <div class="top">

                        <div class="school-title">

                            <h2>
                                SCHOOL ADMISSION FORM
                            </h2>

                            <p>
                                Online Registration Form
                            </p>

                            
                            <p>
                            Student Registration Details
                            </p>

                            <span class="badge blue">
                                Academic Session 2026-27
                            </span>

                            <span class="badge green">
                                New Admission
                            </span>


                        </div>

                        <div class="photo-box">

                            ${photoURL
                ? `<img src="${photoURL}" alt="Student" />`
                : ""
            }

                        </div>

                    </div>

                    <!-- STUDENT INFO -->
                    <h3 class="section-title">
                        Student Information
                    </h3>

                    <div class="grid">

                        <div class="card">
                            <div class="label">Student Name</div>
                            <div class="value">${formData.studentName || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Gender</div>
                            <div class="value">${formData.gender || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Father Name</div>
                            <div class="value">${formData.fatherName || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Mother Name</div>
                            <div class="value">${formData.motherName || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Date Of Birth</div>
                            <div class="value">${formData.dob || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Mobile Number</div>
                            <div class="value">${formData.mobile || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Admission Class</div>
                            <div class="value">${formData.admissionClass || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Subject Stream</div>
                            <div class="value">${formData.stream || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Last School</div>
                            <div class="value">${formData.lastSchool || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Board Type</div>
                            <div class="value">${formData.boardType || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Last Class</div>
                            <div class="value">${formData.lastClass || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Overall Percentage</div>
                            <div class="value">${formData.overallPercentage || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Maths Percentage</div>
                            <div class="value">${formData.mathsPercentage || "N/A"}</div>
                        </div>

                        <div class="card">
                            <div class="label">Science Percentage</div>
                            <div class="value">${formData.sciencePercentage || "N/A"}</div>
                        </div>

                    </div>

                    <!-- QUERY -->
                    <div class="query-section">

                        <h3 class="section-title">
                            Additional Query
                        </h3>

                        <div class="query-box">

                            ${formData.query
                ? formData.query
                : "No additional query submitted."
            }

                        </div>

                    </div>

                    <!-- SIGNATURE -->
                    <div class="signature">

                        <div class="sign-box">
                            Parent / Guardian Signature
                        </div>

                        <div class="sign-box">
                            Authorized Signature
                        </div>

                    </div>

                </div>

            </div>

        </body>

    </html>

    `);

        printWindow.document.close();

        printWindow.focus();

        setTimeout(() => {

            printWindow.print();

            printWindow.onafterprint = () => {

                printWindow.close();

                if (photoURL) {
                    URL.revokeObjectURL(photoURL);
                }

            };

        }, 500);
    };

    return (
        <>
            <section className="w-full bg-[#F5F6FA] py-16 md:py-20">

                <div className="max-w-6xl mx-auto px-4 md:px-8">

                    {/* FORM BOX */}
                    <div className="bg-white border border-gray-200 shadow-md overflow-hidden rounded-sm">

                        {/* HEADER */}
                        <div className="bg-[#072F5F] py-5 px-6">
                            <h2 className="text-center text-white text-2xl md:text-4xl font-bold">
                                Online Registration for New Admission
                            </h2>
                        </div>

                        {/* FORM */}
                        <form
                            onSubmit={handleSubmit}
                            className="p-6 md:p-10"
                        >
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">

                                {/* SUCCESS MESSAGE */}
                                {message && (
                                    <div className="mb-6 bg-green-100 border border-green-500 text-green-700 px-4 py-3 rounded md:col-span-2">
                                        {message}
                                    </div>
                                )}

                                {/* ERROR MESSAGE */}
                                {error && (
                                    <div className="mb-6 bg-red-100 border border-red-500 text-red-700 px-4 py-3 rounded md:col-span-2">
                                        {error}
                                    </div>
                                )}

                                {/* STUDENT NAME */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Student's Name <span className="text-red-500">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        name="studentName"
                                        placeholder="Type Student's Name"
                                        value={formData.studentName}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                        required
                                    />
                                </div>

                                {/* GENDER */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Gender <span className="text-red-500">*</span>
                                    </label>

                                    <select
                                        name="gender"
                                        value={formData.gender}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                        required
                                    >
                                        <option value="">SELECT</option>
                                        <option>Male</option>
                                        <option>Female</option>
                                        <option>Other</option>
                                    </select>
                                </div>

                                {/* FATHER NAME */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Father's Name <span className="text-red-500">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        name="fatherName"
                                        placeholder="Type Father's Name"
                                        value={formData.fatherName}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                        required
                                    />
                                </div>

                                {/* MOTHER NAME */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Mother's Name <span className="text-red-500">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        name="motherName"
                                        placeholder="Mother's Name"
                                        value={formData.motherName}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                        required
                                    />
                                </div>

                                {/* DOB */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Date Of Birth <span className="text-red-500">*</span>
                                    </label>

                                    <input
                                        type="date"
                                        name="dob"
                                        value={formData.dob}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                        required
                                    />
                                </div>

                                {/* MOBILE */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Mobile No <span className="text-red-500">*</span>
                                    </label>

                                    <input
                                        type="number"
                                        name="mobile"
                                        placeholder="Enter 10 Digit Mobile No"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                        required
                                    />
                                </div>

                                {/* CLASS */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Class in which admission is sought for
                                    </label>

                                    <select
                                        name="admissionClass"
                                        value={formData.admissionClass}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                    >
                                        <option value="">SELECT</option>
                                        <option>Nursery</option>
                                        <option>LKG</option>
                                        <option>UKG</option>
                                        <option>1st</option>
                                        <option>2nd</option>
                                        <option>3rd</option>
                                        <option>4th</option>
                                        <option>5th</option>
                                        <option>6th</option>
                                        <option>7th</option>
                                        <option>8th</option>
                                        <option>9th</option>
                                        <option>10th</option>
                                        <option>11th</option>
                                    </select>
                                </div>

                                {/* STREAM */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Subject Stream
                                    </label>

                                    <select
                                        name="stream"
                                        value={formData.stream}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                    >
                                        <option value="">GENERAL SUBJECTS</option>
                                        <option>Maths</option>
                                        <option>Biology</option>
                                        <option>Commerce</option>
                                    </select>
                                </div>

                                {/* LAST SCHOOL */}
                                <div className="md:col-span-2">
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Last School Name
                                    </label>

                                    <input
                                        type="text"
                                        name="lastSchool"
                                        placeholder="Type Last School Name"
                                        value={formData.lastSchool}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                    />
                                </div>

                                {/* BOARD */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Board Type
                                    </label>

                                    <select
                                        name="boardType"
                                        value={formData.boardType}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                    >
                                        <option value="">SELECT</option>
                                        <option>CBSE</option>
                                        <option>ICSE</option>
                                        <option>U.P BOARD</option>
                                        <option>OTHER BOARD</option>
                                    </select>
                                </div>

                                {/* LAST CLASS */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Last Class
                                    </label>

                                    <select
                                        name="lastClass"
                                        value={formData.lastClass}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                    >
                                        <option value="">SELECT</option>
                                        <option>None</option>
                                        <option>LKG</option>
                                        <option>UKG</option>
                                        <option>1</option>
                                        <option>2</option>
                                        <option>3</option>
                                        <option>4</option>
                                        <option>5</option>
                                        <option>6</option>
                                        <option>7</option>
                                        <option>8</option>
                                        <option>9</option>
                                        <option>10</option>
                                        <option>11</option>
                                    </select>
                                </div>

                                {/* PERCENTAGES */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        All Over Percentage
                                    </label>

                                    <input
                                        type="text"
                                        name="overallPercentage"
                                        placeholder="All Over Percentage"
                                        value={formData.overallPercentage}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                    />
                                </div>

                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Math's Percentage
                                    </label>

                                    <input
                                        type="text"
                                        name="mathsPercentage"
                                        placeholder="Maths"
                                        value={formData.mathsPercentage}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                    />
                                </div>

                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Science Percentage
                                    </label>

                                    <input
                                        type="text"
                                        name="sciencePercentage"
                                        placeholder="Science"
                                        value={formData.sciencePercentage}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                    />
                                </div>

                                {/* QUERY */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Any Query (Optional)
                                    </label>

                                    <textarea
                                        rows="4"
                                        name="query"
                                        value={formData.query}
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 outline-none focus:border-[#072F5F]"
                                    />
                                </div>

                                {/* PHOTO */}
                                <div>
                                    <label className="block text-lg font-semibold text-gray-800 mb-2">
                                        Student Photo
                                    </label>

                                    <input
                                        type="file"
                                        name="photo"
                                        onChange={handleChange}
                                        className="w-full border border-gray-400 px-4 py-3 bg-white"
                                    />
                                </div>

                            </div>

                            {/* BUTTONS */}
                            <div className="flex flex-wrap justify-center gap-4 mt-12">

                                {/* PREVIEW BUTTON */}
                                <button
                                    type="button"
                                    onClick={() =>
                                        setShowPreview(true)
                                    }
                                    className="bg-gray-700 hover:bg-black text-white text-lg font-semibold px-10 py-4 rounded-md transition-all duration-300"
                                >
                                    Preview
                                </button>

                                {/* SUBMIT BUTTON */}
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="bg-[#0B5DB7] hover:bg-[#072F5F] text-white text-lg font-semibold px-10 py-4 rounded-md transition-all duration-300 disabled:opacity-50"
                                >

                                    {loading
                                        ? "Submitting..."
                                        : "Submit"}

                                </button>

                                <button
                                    type="button"
                                     onClick={() => navigate("/")}
                                    className="bg-red-600 hover:bg-red-700 text-white text-lg font-semibold px-10 py-4 rounded-md transition-all duration-300"
                                >
                                    Cancle
                                </button>

                            </div>
                        </form>
                    </div>
                </div>
            </section>

            {/* PREVIEW MODAL */}
            {
                showPreview && (

                    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex justify-center items-start overflow-y-auto py-10 px-4">

                        <div className="bg-white w-full max-w-5xl rounded-2xl shadow-2xl overflow-hidden animate-fadeIn">

                            {/* HEADER */}
                            <div className="bg-gradient-to-r from-[#072F5F] to-[#0B5DB7] px-8 py-6 flex justify-between items-center">

                                <div>

                                    <h2 className="text-3xl font-bold text-white">
                                        SCHOOL ADMISSION FORM
                                    </h2>

                                    <p className="text-blue-100 mt-1 text-sm">
                                        Verify all student details before final submission
                                    </p>

                                </div>

                                <button
                                    onClick={() =>
                                        setShowPreview(false)
                                    }
                                    className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 text-white text-2xl flex items-center justify-center transition-all duration-300"
                                >
                                    ×
                                </button>

                            </div>

                            {/* CONTENT */}
                            <div
                                ref={printRef}
                                className="p-8 md:p-12 bg-[#F8FAFC]"
                            >

                                {/* TOP SECTION */}
                                <div className="flex flex-col md:flex-row justify-between items-center gap-8 border-b border-gray-300 pb-8">

                                    {/* SCHOOL INFO */}
                                    <div className="text-center md:text-left">

                                        <h1 className="text-4xl font-extrabold text-[#072F5F] tracking-wide">
                                            Registration Form
                                        </h1>

                                        <p className="text-gray-600 mt-3 text-lg">
                                            Online Registration
                                        </p>

                                        <div className="mt-4 flex flex-wrap gap-3 justify-center md:justify-start">

                                            <span className="bg-blue-100 text-[#072F5F] px-4 py-1 rounded-full text-sm font-semibold">
                                                Academic Session 2026-27
                                            </span>

                                            <span className="bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-semibold">
                                                New Admission
                                            </span>

                                        </div>

                                    </div>

                                    {/* PHOTO */}
                                    {
                                        formData.photo ? (

                                            <div className="bg-white p-2 rounded-xl shadow-md border border-gray-200">

                                                <img
                                                    src={URL.createObjectURL(formData.photo)}
                                                    alt="Student"
                                                    className="w-40 h-44 object-cover rounded-lg"
                                                />

                                            </div>

                                        ) : (

                                            <div className="w-40 h-44 bg-gray-200 rounded-xl flex items-center justify-center text-gray-500 text-sm">
                                                No Photo
                                            </div>

                                        )
                                    }

                                </div>

                                {/* STUDENT DETAILS */}
                                <div className="mt-10">

                                    <div className="flex items-center gap-3 mb-6">

                                        <div className="w-2 h-8 bg-[#0B5DB7] rounded-full"></div>

                                        <h3 className="text-2xl font-bold text-[#072F5F]">
                                            Student Information
                                        </h3>

                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        <PreviewItem
                                            label="Student Name"
                                            value={formData.studentName}
                                        />

                                        <PreviewItem
                                            label="Gender"
                                            value={formData.gender}
                                        />

                                        <PreviewItem
                                            label="Father Name"
                                            value={formData.fatherName}
                                        />

                                        <PreviewItem
                                            label="Mother Name"
                                            value={formData.motherName}
                                        />

                                        <PreviewItem
                                            label="Date Of Birth"
                                            value={formData.dob}
                                        />

                                        <PreviewItem
                                            label="Mobile Number"
                                            value={formData.mobile}
                                        />

                                        <PreviewItem
                                            label="Admission Class"
                                            value={formData.admissionClass}
                                        />

                                        <PreviewItem
                                            label="Subject Stream"
                                            value={formData.stream}
                                        />

                                        <PreviewItem
                                            label="Last School"
                                            value={formData.lastSchool}
                                        />

                                        <PreviewItem
                                            label="Board Type"
                                            value={formData.boardType}
                                        />

                                        <PreviewItem
                                            label="Last Class"
                                            value={formData.lastClass}
                                        />

                                        <PreviewItem
                                            label="Overall Percentage"
                                            value={formData.overallPercentage}
                                        />

                                        <PreviewItem
                                            label="Maths Percentage"
                                            value={formData.mathsPercentage}
                                        />

                                        <PreviewItem
                                            label="Science Percentage"
                                            value={formData.sciencePercentage}
                                        />

                                    </div>

                                </div>

                                {/* QUERY */}
                                <div className="mt-10">

                                    <div className="flex items-center gap-3 mb-6">

                                        <div className="w-2 h-8 bg-[#0B5DB7] rounded-full"></div>

                                        <h3 className="text-2xl font-bold text-[#072F5F]">
                                            Additional Query
                                        </h3>

                                    </div>

                                    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm min-h-[120px] text-gray-700 leading-relaxed">

                                        {
                                            formData.query
                                                ? formData.query
                                                : "No additional query submitted."
                                        }

                                    </div>

                                </div>

                                {/* SIGNATURE SECTION */}
                                <div className="mt-16 flex flex-col md:flex-row justify-between gap-10">

                                    <div className="flex-1 border-t border-gray-400 pt-3 text-center text-gray-600 font-medium">
                                        Parent / Guardian Signature
                                    </div>

                                    <div className="flex-1 border-t border-gray-400 pt-3 text-center text-gray-600 font-medium">
                                        Authorized Signature
                                    </div>

                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="bg-white border-t border-gray-200 px-8 py-6 flex flex-wrap justify-center gap-4">

                                {/* DOWNLOAD */}
                                <button
                                    onClick={handleDownload}
                                    className="bg-green-600 hover:bg-green-700 text-white font-semibold px-10 py-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300"
                                >
                                    Download Form
                                </button>

                                {/* CLOSE */}
                                <button
                                    onClick={() =>
                                        setShowPreview(false)
                                    }
                                    className="bg-red-600 hover:bg-red-700 text-white font-semibold px-10 py-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300"
                                >
                                    Close
                                </button>

                            </div>

                        </div>

                    </div>

                )
            }
        </>
    );
};

export default OnlineRegistration;